import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Tabs,
  Tab,
  Drawer,
  Modal,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import AddUser from "./AddUser";
import NewUserApproval from "./NewUserApproval";
import { useLocation, useNavigate } from "react-router";
import { BarLoader } from "react-spinners";
import { toast } from "react-toastify";
import { IoIosClose, IoMdInformationCircleOutline } from "react-icons/io";
import axios from "axios";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import Select from "react-select";

import CloseIcon from "@mui/icons-material/Close";

function ViewUsers() {
  const location = useLocation();
  const navigate = useNavigate();
  const { notification } = location.state || {};
  const firstNameRef = useRef(null);
  // Default to tab 0 (Existing Users)
  const [value, setValue] = useState(0);
  const [notificationData, setNotificationData] = useState(null);

  const [users, setUsers] = useState([]);
  const [userView, setUserView] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedRole, setSelectedRole] = useState("contractor");
  const [showAll, setShowAll] = React.useState(false);
  const [invalidFiles, setInvalidFiles] = useState([]);
  const [sortConfig, setSortConfig] = React.useState({
    key: null,
    direction: "asc",
  });
  const [expandedRowId, setExpandedRowId] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [roleFilter, setRoleFilter] = React.useState("Contractor");

  const [previewModaTitle, setPreviewModaTitle] = useState("");
  const [previewModal, setPreviewModal] = useState(false);
  const [selectedPdfFile, setSelectedPdfFile] = useState(null);
  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [zipError, setZipError] = useState("");
  const [yearError, setYearError] = useState("");
  const [emptyFields, setEmptyFields] = useState(false);
  const currentYear = new Date().getFullYear();
  const startYear = 1900;
  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(year.toString());
  }

  const yearOptions = Array.from(
    { length: new Date().getFullYear() - 1899 },
    (_, i) => new Date().getFullYear() - i
  ).map((year) => ({ value: year, label: year }));

  const [isLoader, setIsLoader] = React.useState(false);
  const [showDocuments, setShowDocuments] = React.useState(false);
  const [viewReport, setViewReport] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState("");

  const [fileError, setFileError] = React.useState("");
  const controllerRef = React.useRef(null);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [emailErrors, setEmailErrors] = useState("");
  const [errors, setErrors] = useState({});
  const [step, setStep] = useState(1);
  const [issubmitting, setissubmitting] = useState(false);

  const steps = ["Personal Details", "Company & Bank Details"];
  const [routingNumError, setRoutingNumError] = useState("");
  const [accountNumError, setAccountNumError] = useState("");
  const [phoneNumError, setPhoneNumError] = useState("");

  const [formData, setFormData] = useState({
    email: "",
    role: "owner",
    username: "",
    firstName: "",
    lastName: "",
    phone: "",
    address: "",
    city: "",
    stateName: "",
    zip: "",
    companyName: "",
    yearFounded: "",
    employees: "",
    contractorLicense: "",
    accountHolder: "",
    bankName: "",
    routingNumber: "",
    accountNumber: "",
    coOwnerName: "",
    password: "",
    // formationDoc: null,
    photoID: null,
    // EINLetter: null,
    // IRSForm: null,
    confirmPassword: "",
    // KYCBeneficial: null,
    CopyOfID: null,
    designation: "Commercial Building Inspector",
    AdditionalDocuments: null,
  });

  const borderStyle = (field) =>
    emptyFields[field] ? { border: "1px solid red" } : { borderRadius: "6px" };
  const iframeStyleContractDocs = {
    width: "100%",
    height: "80vh",
    border: "none", // Remove iframe border if needed
  };

  const iframeStyleContractPdf = {
    width: "100%",
    height: "80vh",
    border: "none", // Remove iframe border if needed
  };

  // When notification exists, switch to "New User(s)" tab
  useEffect(() => {
    if (notification) {
      setValue(0); // Switch to "New User(s)" tab
      setNotificationData(notification);
      // Clear the state from the navigation history
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [notification, navigate, location.pathname]);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});

  const headers = {
    "X-CSRFToken": cookies.csrftoken,
    "Content-Type": "multipart/form-data",
  };
  const [errorMsg, setErrorMsg] = useState("");

  const validatePassword = (password) => {
    if (!password) return false; // empty = not valid
    // accepts any non-alphanumeric as special character
    const strongPasswordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;
    return strongPasswordRegex.test(password);
  };
  const validateStep = () => {
    let required = [];

    if (step === 1) {
      required = [
        "firstName",
        "lastName",
        "email",
        "phone",
        "address",
        "city",
        "stateName",
        "zip",
        // "password",
        // "confirmPassword",
        "companyName",
        "yearFounded",
        "employees",
        "contractorLicense",
        "accountHolder",
        "bankName",
        "routingNumber",
        "accountNumber",
        // "formationDoc",
        "photoID",
        // "EINLetter",
        // "IRSForm",
        "AdditionalDocuments",
      ];
    }

    const newEmptyFields = {};
    let valid = true;

    required.forEach((field) => {
      if (!String(formData[field] ?? "").trim()) {
        newEmptyFields[field] = true;
        valid = false;
      }
    });

    setEmptyFields(newEmptyFields);

    if (!valid) {
      toast.error("Please fill all required fields!");
      return false;
    }

    if (step === 2 && formData.password !== formData.confirmPassword) {
      toast.error("Passwords do not match!");
      return false;
    }

    return true;
  };

  const validateOwnerStep = () => {
    let required = [];

    required = [
      "firstName",
      "lastName",
      "email",
      "phone",
      "address",
      "city",
      "stateName",
      "zip",
      // "password",
      // "confirmPassword",
      "accountHolder",
      "bankName",
      "routingNumber",
      "accountNumber",
      // "KYCBeneficial",
      "CopyOfID",
      // "IRSForm",
      "coOwnerName",
      "AdditionalDocuments",
    ];

    const newEmptyFields = {};
    let valid = true;

    required.forEach((field) => {
      if (!String(formData[field] ?? "").trim()) {
        newEmptyFields[field] = true;
        valid = false;
      }
    });

    setEmptyFields(newEmptyFields);

    if (!valid) {
      toast.error("Please fill all required fields!");
      return false;
    }

    return true;
  };
  const clearSingleFile = (name, index) => {
    setFormData((prev) => {
      const updatedFiles = prev[name].filter((_, i) => i !== index);
      return {
        ...prev,
        [name]: updatedFiles.length > 0 ? updatedFiles : null, // ✅ set to null when empty
      };
    });

    // Optional: clear error if applicable
    setErrors((prev) => ({ ...prev, [name]: "" }));

    // ✅ Reset input value (if all cleared)
    const input = document.getElementById(name);
    if (input) input.value = "";
  };
  const validateInspectorStep = () => {
    const required = ["firstName", "lastName", "email", "phone", "designation"];
    const newEmptyFields = {};
    let valid = true;

    required.forEach((field) => {
      if (!String(formData[field] ?? "").trim()) {
        newEmptyFields[field] = true;
        valid = false;
      }
    });

    setEmptyFields(newEmptyFields);

    if (!valid) {
      toast.error("Please fill all required fields!");
      return false;
    }

    return true;
  };
  const maxSizes = {
    formationDoc: 20 * 1024 * 1024, // 20 MB
    photoID: 20 * 1024 * 1024, // 20 MB
    EINLetter: 10 * 1024 * 1024, // 10 MB
    IRSForm: 10 * 1024 * 1024, // 10 MB
    CopyOfID: 20 * 1024 * 1024, // 20 MB
    KYCBeneficial: 10 * 1024 * 1024, // 10 MB
    AdditionalDocuments: 10 * 1024 * 1024, // 10 MB
  };

  const allowedTypes = {
    formationDoc: ["application/pdf", "image/png", "image/jpeg"],
    photoID: ["application/pdf", "image/png", "image/jpeg"],
    EINLetter: ["application/pdf"],
    IRSForm: ["application/pdf"],
    CopyOfID: ["application/pdf", "image/png", "image/jpeg"],
    KYCBeneficial: ["application/pdf"],
    AdditionalDocuments: [
      "application/pdf",
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    ],
  };

  const validateZipCode = (value) => {
    const zip = value.trim();

    if (zip.length !== 5) {
      setZipError("Please enter a valid Zip code");
      setEmptyFields((prev) => ({
        ...prev,
        zip: true,
      }));
      return false;
    }

    // Check if all characters are zeros (any length)
    if (/^0{5}$/.test(zip)) {
      setZipError("Please enter a valid Zip code");
      setEmptyFields((prev) => ({
        ...prev,
        zip: true,
      }));
      return false;
    }

    return true;
  };

  const clearFile = (name) => {
    setFormData((prev) => ({ ...prev, [name]: null }));
    setErrors((prev) => ({ ...prev, [name]: "" }));

    // ✅ Reset the file input value so same file can be uploaded again
    const input = document.getElementById(name);
    if (input) input.value = "";
  };
  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    if (name === "role") {
      setFormData({
        email: "",
        role: value,
        username: "",
        firstName: "",
        lastName: "",
        phone: "",
        address: "",
        city: "",
        stateName: "",
        zip: "",
        companyName: "",
        yearFounded: "",
        employees: "",
        contractorLicense: "",
        accountHolder: "",
        bankName: "",
        routingNumber: "",
        accountNumber: "",
        coOwnerName: "",
        password: "",
        // formationDoc: null,
        photoID: null,
        // EINLetter: null,
        // IRSForm: null,
        confirmPassword: "",
        // KYCBeneficial: null,
        CopyOfID: null,
        designation: "Commercial Building Inspector",
        AdditionalDocuments: null,
      });
    }

    // --- FILE UPLOAD HANDLING ---
    if (type === "file") {
      e.preventDefault();
      const input = e.target; // get input reference
      const files = input.files;

      if (!files || files.length === 0) {
        setErrors((prev) => ({ ...prev, [name]: "" }));
        setEmptyFields((prev) => ({ ...prev, [name]: false }));
        setFormData((prev) => ({
          ...prev,
          [name]: name === "photoID" ? null : [],
        }));
        input.value = ""; // reset input value so same file can trigger again
        return;
      }

      const maxSize = maxSizes[name];
      const allowed = allowedTypes[name];
      const fileArray = Array.from(files);

      const existingFiles = Array.isArray(formData[name])
        ? formData[name]
        : formData[name]
        ? [formData[name]]
        : [];

      // ✅ Restrict total number of files to 10
      const totalFilesCount = existingFiles.length + fileArray.length;
      if (totalFilesCount > 10) {
        toast.warning("You cannot upload more than 10 files.");
        input.value = ""; // reset input
        return;
      }

      // ✅ Check for duplicate file names
      const duplicateFile = fileArray.find((newFile) =>
        existingFiles.some((existing) => existing.name === newFile.name)
      );

      if (duplicateFile) {
        toast.warning(`File "${duplicateFile.name}" already uploaded.`);
        input.value = ""; // reset input so same-file selection triggers again
        return;
      }

      // ✅ Validate file type and size
      const invalidFiles = fileArray.filter(
        (file) => !allowed.includes(file.type) || file.size > maxSize
      );

      if (invalidFiles.length > 0) {
        const invalid = invalidFiles[0];
        if (!allowed.includes(invalid.type)) {
          setErrors((prev) => ({
            ...prev,
            [name]: `Invalid file type. Allowed: ${allowed
              .map((t) => t.split("/")[1]?.toUpperCase() || t)
              .join(", ")}.`,
          }));
        } else if (invalid.size > maxSize) {
          const mb = maxSize / (1024 * 1024);
          setErrors((prev) => ({
            ...prev,
            [name]: `File "${invalid.name}" exceeds ${mb}MB limit.`,
          }));
        }
        setEmptyFields((prev) => ({ ...prev, [name]: true }));
        input.value = ""; // reset input again
        return;
      }

      // ✅ Clear errors and set files
      setErrors((prev) => ({ ...prev, [name]: "" }));
      setEmptyFields((prev) => ({ ...prev, [name]: false }));
      setFormData((prev) => ({
        ...prev,
        [name]:
          name === "photoID"
            ? fileArray[0]
            : [...(prev[name] || []), ...fileArray],
      }));

      input.value = ""; // ✅ Always reset at the end
      return;
    }

    // --- NON-FILE INPUT HANDLING ---
    if (name === "email") setEmailErrors("");
    if (name === "routingNumber") setRoutingNumError("");
    if (name === "accountNumber") setAccountNumError("");
    if (name === "zip") setZipError("");
    if (name === "phone") setPhoneNumError("");

    setFormData((prev) => {
      const trimmedValue = [
        "password",
        "confirmPassword",
        "phone",
        "zip",
      ].includes(name)
        ? value
        : typeof value === "string"
        ? value.trimStart()
        : value;

      const updated = { ...prev, [name]: trimmedValue };

      // --- Auto-generate username ---
      if (name === "firstName" || name === "lastName") {
        updated.username = `${updated.firstName} ${updated.lastName}`.trim();
      }

      if (name === "role") updated.role = value;

      // --- Phone formatting ---
      if (name === "phone") {
        const formatted = formatPhoneNumber(value);
        updated.phone = formatted;
      }

      // --- Year validation ---
      if (name === "yearFounded") {
        const isValidYear = validateYear(value);
        setEmptyFields((prev) => ({ ...prev, yearFounded: !isValidYear }));
      }

      // --- ZIP validation ---
      if (name === "zip") {
        let digitsOnly = value.replace(/\D/g, "");
        if (digitsOnly.length > 5) digitsOnly = digitsOnly.slice(0, 5);
        updated.zip = digitsOnly;

        const isValidZip = digitsOnly.length === 5;
        setEmptyFields((prev) => ({ ...prev, zip: !isValidZip }));
      }

      // --- Date validation ---
      if (name === "dayOfBirth") {
        const isValidDate = validateDate(value);
        setEmptyFields((prev) => ({ ...prev, dayOfBirth: !isValidDate }));
      }

      // --- Password validation ---
      if (name === "password" || name === "confirmPassword") {
        const password = updated.password;
        const confirmPassword = updated.confirmPassword;
        const passwordValid = validatePassword(password);
        const passwordsMatch = password === confirmPassword;
        const passwordEmpty = !password;
        const confirmEmpty = !confirmPassword;

        setPasswordError("");

        if (passwordEmpty && confirmEmpty) {
          setEmptyFields((prev) => ({
            ...prev,
            password: false,
            confirmPassword: false,
          }));
        } else if (!passwordValid && !passwordEmpty) {
          setPasswordError(
            "Password must be at least 8 characters long and contain at least one letter, one number, and one special character."
          );
          setEmptyFields((prev) => ({
            ...prev,
            password: true,
            confirmPassword: false,
          }));
        } else if (passwordValid && confirmPassword && !passwordsMatch) {
          setPasswordError("Passwords do not match.");
          setEmptyFields((prev) => ({
            ...prev,
            password: false,
            confirmPassword: true,
          }));
        } else {
          setPasswordError("");
          setEmptyFields((prev) => ({
            ...prev,
            password: false,
            confirmPassword: false,
          }));
        }
      } else {
        setEmptyFields((prev) => ({ ...prev, [name]: false }));
      }

      return updated;
    });
  };

  const uploadContractorFields = [
    // {
    //   name: "formationDoc",
    //   label: "Formation Document",
    //   tooltip: "Accepted formats: PDF, PNG, JPG, JPEG (Max 20MB).",
    //   accept: ".pdf, image/png, image/jpeg",
    //   maxSize: 20 * 1024 * 1024, // 20MB
    // },
    {
      name: "photoID",
      label: "Photo ID",
      tooltip: "Accepted formats: PDF, PNG, JPG, JPEG (Max 20MB).",
      accept: ".pdf, image/png, image/jpeg",
      maxSize: 20 * 1024 * 1024, // 20MB
    },
    // {
    //   name: "EINLetter",
    //   label: "EIN Confirmation Letter",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    // {
    //   name: "IRSForm",
    //   label: "IRS Form W-9",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    {
      name: "AdditionalDocuments",
      label: "Additional Documents",
      tooltip:
        "You can upload up to 10 files. Each file must be a PDF or Excel document and not exceed 10 MB.",
      accept: ".pdf, .xls, .xlsx",
      maxSize: 10 * 1024 * 1024, // 10MB
    },
  ];

  const uploadOwnerFields = [
    // {
    //   name: "KYCBeneficial",
    //   label: "KYC Beneficial Ownership Certificate",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    {
      name: "CopyOfID",
      label: "Photo ID",
      tooltip: "Accepted formats: PDF, PNG, JPG, JPEG (Max 20MB).",
      accept: ".pdf, image/png, image/jpeg",
      maxSize: 20 * 1024 * 1024, // 20MB
    },
    // {
    //   name: "EINLetter",
    //   label: "EIN Confirmation Letter",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    // {
    //   name: "IRSForm",
    //   label: "IRS Form W-9",
    //   tooltip: "Only PDF files are accepted (Max 10MB).",
    //   accept: ".pdf",
    //   maxSize: 10 * 1024 * 1024, // 10MB
    // },
    {
      name: "AdditionalDocuments",
      label: "Additional Documents",
      tooltip:
        "You can upload up to 10 files. Each file must be a PDF or Excel document and not exceed 10 MB.",
      accept: ".pdf, .xls, .xlsx",
      maxSize: 10 * 1024 * 1024, // 10MB
    },
  ];
  const validateFilesExist = async (files = []) => {
    if (!files || files.length === 0)
      return { isValid: true, invalidFiles: [] };

    const invalidFiles = [];

    for (const fileObj of files) {
      const file = fileObj?.originalFile || fileObj?.file || fileObj;
      const fileName = fileObj?.name || "Unknown file";

      try {
        if (!(file instanceof File)) {
          invalidFiles.push(fileName);
          continue;
        }

        if (typeof file.arrayBuffer === "function") {
          await file.arrayBuffer();
        } else {
          await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve();
            reader.onerror = () => reject(new Error("Unable to read file."));
            reader.readAsArrayBuffer(file);
          });
        }
      } catch (err) {
        console.error(`Error reading file: ${fileName}`, err);
        invalidFiles.push(fileName);
      }
    }

    return {
      isValid: invalidFiles.length === 0,
      invalidFiles,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // ✅ Role-based validation
    if (formData.role === "contractor" && !validateStep()) return;
    if (formData.role === "owner" && !validateOwnerStep()) return;
    if (formData.role === "inspector" && !validateInspectorStep()) return;

    // ✅ General field validation
    const validations = [
      validateEmail(formData.email),
      validatePhoneNumber(formData.phone),
      formData?.role !== "inspector" ? validateZipCode(formData.zip) : true,
      formData?.role !== "inspector"
        ? validateRoutingNumber(formData.routingNumber)
        : true,
      formData?.role !== "inspector"
        ? validateAccountNumber(formData.accountNumber)
        : true,
    ];

    if (validations.includes(false)) {
      // toast.error("Please fix validation errors before submitting.");
      return;
    }

    // ✅ Validate uploaded files
    let allFilesValid = true;
    let invalidFileNames = [];

    const fileGroups = [];

    if (formData.role === "contractor") {
      // fileGroups.push(formData.contractorLicense);
      fileGroups.push(formData.photoID);
      if (formData.AdditionalDocuments?.length)
        fileGroups.push(...formData.AdditionalDocuments);
    } else if (formData.role === "owner") {
      if (formData.CopyOfID?.length) fileGroups.push(...formData.CopyOfID);
      if (formData.AdditionalDocuments?.length)
        fileGroups.push(...formData.AdditionalDocuments);
    }

    const { isValid, invalidFiles } = await validateFilesExist(fileGroups);

    if (!isValid) {
      allFilesValid = false;
      setInvalidFiles(invalidFiles); // 🟥 store invalid file names

      setEmptyFields((prev) => ({
        ...prev,
        fileError: true,
      }));

      const fileList = invalidFiles.join(", ");
      toast.warning(
        `Some files could not be read or are missing: ${fileList}. Please re-upload them.`
      );

      console.warn("Invalid files:", invalidFiles);
      return;
    } else {
      setInvalidFiles([]); // clear previous errors if everything’s valid
    }

    // ✅ Build FormData based on role
    const formPayload = new FormData();
    formPayload.append("role", formData.role.toLowerCase());
    formPayload.append("email", formData.email);
    formPayload.append(
      "user_name",
      formData.username || `${formData.firstName} ${formData.lastName}`
    );
    formPayload.append("phone", formData.phone);

    if (formData.password) formPayload.append("password", formData.password);

    // ✅ Shared fields for all non-inspector roles
    if (formData.role !== "inspector") {
      formPayload.append("address", formData.address || "");
      formPayload.append("city", formData.city || "");
      formPayload.append("state", formData.stateName || "");
      formPayload.append("zip", formData.zip || "");
    }

    // ✅ Role-specific data
    if (formData.role === "contractor") {
      formPayload.append("company_name", formData.companyName || "");
      formPayload.append("cmp_found_year", formData.yearFounded || "");
      formPayload.append("no_of_employes", formData.employees || "");
      formPayload.append("accountname", formData.accountHolder || "");
      formPayload.append("bankname", formData.bankName || "");
      formPayload.append("routing_number", formData.routingNumber || "");
      formPayload.append("acnum", formData.accountNumber || "");

      if (formData.contractorLicense)
        formPayload.append("certificates", formData.contractorLicense);
      if (formData.photoID) formPayload.append("photo_id", formData.photoID);
      if (
        formData.AdditionalDocuments &&
        formData.AdditionalDocuments.length > 0
      ) {
        formData.AdditionalDocuments.forEach((file) => {
          formPayload.append("additional_documents", file);
        });
      }
      // if (formData.formationDoc)
      //   formPayload.append("formation_document", formData.formationDoc);
      // if (formData.IRSForm) formPayload.append("irs_form", formData.IRSForm);
      // if (formData.EINLetter)
      //   formPayload.append("ein_confirmation_letter", formData.EINLetter);
    } else if (formData.role === "Project Owner" || formData.role === "owner") {
      formPayload.append("co_owner", formData.coOwnerName || "");
      formPayload.append("accountname", formData.accountHolder || "");
      formPayload.append("bankname", formData.bankName || "");
      formPayload.append("routing_number", formData.routingNumber || "");
      formPayload.append("acnum", formData.accountNumber || "");

      if (formData.CopyOfID)
        formPayload.append("photo_id", formData.CopyOfID?.[0]);
      // if (formData.KYCBeneficial)
      //   formPayload.append("kyc_ownership_certificate", formData.KYCBeneficial);
      // if (formData.IRSForm) formPayload.append("irs_form", formData.IRSForm);
      // if (formData.EINLetter)
      //   formPayload.append("ein_confirmation_letter", formData.EINLetter);
      if (
        formData.AdditionalDocuments &&
        formData.AdditionalDocuments.length > 0
      ) {
        formData.AdditionalDocuments.forEach((file) => {
          formPayload.append("additional_documents", file);
        });
      }
    }

    // ✅ Inspector-specific payload
    else if (formData.role === "inspector") {
      formPayload.append("designation", formData.designation || "");
      // add more inspector fields if needed
    }

    // ✅ Submit
    try {
      setissubmitting(true);
      await axios.post("/cvault/create-user-by-admin/", formPayload, {
        headers: headers,
      });

      toast.success("Registration successful!");
      // setTimeout(() => navigate("/login"), 1500);
      // setLoader(false);
      setEmptyFields(false);
      setFormData({
        email: "",
        role: "owner",
        username: "",
        firstName: "",
        lastName: "",
        phone: "",
        address: "",
        city: "",
        stateName: "",
        zip: "",
        companyName: "",
        yearFounded: "",
        employees: "",
        contractorLicense: "",
        accountHolder: "",
        bankName: "",
        routingNumber: "",
        accountNumber: "",
        coOwnerName: "",
        password: "",
        // formationDoc: null,
        photoID: null,
        // EINLetter: null,
        // IRSForm: null,
        confirmPassword: "",
        // KYCBeneficial: null,
        CopyOfID: null,
        designation: "Commercial Building Inspector",
        AdditionalDocuments: null,
      });
      setUserView(false);
      localStorage.setItem("value", 1);
      window.location.reload();
    } catch (error) {
      console.error(error);
      // setLoader(false);
      setEmptyFields(false);
      // setUserView(false);
      toast.error(error?.response?.data?.error || "Registration failed");
    } finally {
      setissubmitting(false);
    }
  };
  useEffect(() => {
    const savedValue = localStorage.getItem("value");
    if (savedValue) {
      setValue(Number(savedValue));
    }
  }, []);

  const handleBlur = async (event) => {
    const inputValue = event.target.value;
    if (event.target.name === "email" && !validateEmail(inputValue)) {
      if (inputValue !== "") {
        // toast.error("Invalid email");
        setEmailError("Invalid Email");
      }
    } else if (
      event.target.name === "phone" &&
      !validatePhoneNumber(inputValue)
    ) {
      if (inputValue !== "") {
        // toast.error("Invalid Phone Number");
        setPhoneError("Invalid Phone Number");
      }
    } else if (event.target.name === "zip" && !validateZipCode(inputValue)) {
      // toast.error("Invalid Zip code");
      setZipError("Invalid Zip code");
    } else if (event.target.name === "date" && !validateDate(inputValue)) {
      if (inputValue !== "") {
        toast.error(" Please enter a number between 1 and 30.");
      }
    } else if (
      event.target.name === "cmp_found_year" &&
      !validateYear(inputValue)
    ) {
      if (inputValue !== "") {
        setYearError("Please enter a valid year");
      }
    }
    if (event.target.name === "email" && validateEmail(inputValue)) {
      try {
        var response = await axios.get(
          `/cvault/user-existance/?email=${inputValue}`
        );

        if (response?.data?.result) {
          // setState((prev) => ({
          //   ...prev,
          //   phone: response?.data?.data?.contact_info || "",
          //   user_name: response?.data?.data?.user_name || "",
          //   address: response?.data?.data?.address || "",
          //   city: response?.data?.data?.city || "",
          //   state: response?.data?.data?.state || "",
          //   zip: response?.data?.data?.zip_code || "",
          // }));
          setEmailError("User already exists");
        } else {
          // setState((prev) => ({
          //   ...prev,
          //   phone: "",
          //   user_name: "",
          //   address: "",
          //   city: "",
          //   state: "",
          //   zip: "",
          // }));
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again later");
      }
    }
  };

  const validateDate = (date) => {
    const parsedDate = parseInt(date, 10);
    return !isNaN(parsedDate) && parsedDate >= 1 && parsedDate <= 30;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateYear = (year) => {
    const currentYear = new Date().getFullYear();
    return /^\d{4}$/.test(year) && year >= 1000 && year <= currentYear;
  };

  const formatPhoneNumber = (input) => {
    const digits = input.replace(/\D/g, "").replace(/^1/, "").slice(0, 10); // remove non-digits and trim to 10

    const parts = [];
    if (digits.length > 0) parts.push("(" + digits.slice(0, 3));
    if (digits.length >= 3) parts.push(") " + digits.slice(3, 6));
    if (digits.length >= 6) parts.push("-" + digits.slice(6, 10));

    return "+1 " + parts.join("");
  };

  const validatePhoneNumber = (val) => {
    if (val && typeof val === "string") {
      const regex = /^\+1\s\(\d{3}\)\s\d{3}-\d{4}$/;

      // Check format first
      if (!regex.test(val)) {
        setPhoneNumError("Please enter a valid phone number");
        setEmptyFields((prev) => ({
          ...prev,
          phone: true,
        }));
        return false;
      }

      // Remove all non-digit characters
      const digitsOnly = val.replace(/\D/g, "");

      // Check if all digits (after +1) are zeros
      if (/^0+$/.test(digitsOnly.slice(1))) {
        setPhoneNumError("Please enter a valid phone number");
        setEmptyFields((prev) => ({
          ...prev,
          phone: true,
        }));
        return false;
      }

      // If valid, clear any previous errors
      setPhoneNumError("");
      setEmptyFields((prev) => ({
        ...prev,
        phone: false,
      }));

      return true;
    }

    // Handle empty or invalid type
    setPhoneNumError("Phone number is required.");
    setEmptyFields((prev) => ({
      ...prev,
      phone: true,
    }));

    return false;
  };

  const validateRoutingNumber = (value) => {
    const routingNumber = value.trim();

    // Check length
    if (routingNumber.length !== 9) {
      setRoutingNumError("Please enter a valid Routing number");
      setEmptyFields((prev) => ({
        ...prev,
        routingNumber: true,
      }));
      return false;
    }

    // Check if all digits are 0
    if (/^0{9}$/.test(routingNumber)) {
      setRoutingNumError("Please enter a valid Routing number");
      setEmptyFields((prev) => ({
        ...prev,
        routingNumber: true,
      }));
      return false;
    }

    return true;
  };
  const validateAccountNumber = (value) => {
    const accountNumber = value.trim();

    // Check if all characters are zeros (any length)
    if (/^0+$/.test(accountNumber)) {
      setAccountNumError("Please enter a valid account number");
      setEmptyFields((prev) => ({
        ...prev,
        accountNumber: true,
      }));
      return false;
    }

    return true;
  };

  console.log(accountNumError, "accountNumError");

  return (
    <Box className="card p-3 card-cvault ms-4 me-4 mb-3 mt-3">
      {/* Tabs Header */}
      {/* Tabs + Button Row */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
        }}
      >
        {/* LEFT: Tabs */}
        <Tabs
          value={value}
          onChange={handleTabChange}
          indicatorColor="primary"
          sx={{
            "& .MuiTabs-indicator": { backgroundColor: "#f5ae41" },
          }}
        >
          <Tab
            label="New User(s)"
            sx={{
              "&.Mui-selected": {
                color: "#f5ae41",
                fontWeight: 550,
              },
            }}
          />
          <Tab
            label="Existing Users"
            sx={{
              "&.Mui-selected": {
                color: "#f5ae41",
                fontWeight: 550,
              },
            }}
          />
        </Tabs>

        {/* RIGHT: Create Button */}
        <button
          className="btn btn-cvault ms-2"
          onClick={() => {
            setUserView(true);
            // getUsers();
            setSearch("");
            setSelectedRole("contractor");
          }}
          style={{ fontSize: "14px", width: "10rem" }}
        >
          Create User
        </button>
      </Box>

      {/* Tab Panels */}
      <Box sx={{ mt: 0 }}>
        {value === 1 && <AddUser />}
        {value === 0 && (
          <NewUserApproval
            notification={notificationData}
            setNotificationData={setNotificationData}
          />
        )}
      </Box>

      <Drawer
        variant="temporary"
        anchor="right"
        open={userView}
        onClose={() => {
          setUserView(false);
          setSearch("");
          setEmailError("");
          setPhoneError("");
          setZipError("");
          setRoutingNumError("");
          setAccountNumError("");
          setYearError("");
          setEmptyFields(false);
          setFormData({
            email: "",
            role: "owner",
            username: "",
            firstName: "",
            lastName: "",
            phone: "",
            address: "",
            city: "",
            stateName: "",
            zip: "",
            companyName: "",
            yearFounded: "",
            employees: "",
            contractorLicense: "",
            accountHolder: "",
            bankName: "",
            routingNumber: "",
            accountNumber: "",
            coOwnerName: "",
            password: "",
            // formationDoc: null,
            photoID: null,
            // EINLetter: null,
            // IRSForm: null,
            confirmPassword: "",
            // KYCBeneficial: null,
            CopyOfID: null,
            designation: "Commercial Building Inspector",
            AdditionalDocuments: null,
          });
        }}
        sx={{
          width: "60%",
          flexShrink: 0,
          "& .MuiDrawer-paper": { width: "60%", boxSizing: "border-box" },
        }}
      >
        {/* ===== HEADER ===== */}

        <div
          style={{
            position: "sticky",
            top: 0,
            background: "#fff",
            zIndex: 100,
            padding: "16px 24px",
            borderBottom: "1px solid #ddd",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h4 className="fw-bold m-0" style={{ fontSize: "22px" }}>
            Create User
          </h4>
          <CloseIcon
            onClick={() => {
              setUserView(false);
              setSearch("");
              setEmptyFields(false);
              setEmailError("");
              setPhoneError("");
              setZipError("");
              setYearError("");
              setFormData({
                email: "",
                role: "owner",
                username: "",
                firstName: "",
                lastName: "",
                phone: "",
                address: "",
                city: "",
                stateName: "",
                zip: "",
                companyName: "",
                yearFounded: "",
                employees: "",
                contractorLicense: "",
                accountHolder: "",
                bankName: "",
                routingNumber: "",
                accountNumber: "",
                coOwnerName: "",
                password: "",
                // formationDoc: null,
                photoID: null,
                // EINLetter: null,
                // IRSForm: null,
                confirmPassword: "",
                // KYCBeneficial: null,
                CopyOfID: null,
                designation: "Commercial Building Inspector",
                AdditionalDocuments: null,
              });
            }}
            style={{
              cursor: "pointer",
              fontSize: "28px",
            }}
          />
        </div>
        {/* ===== CONTENT SCROLL AREA ===== */}
        <form
          onSubmit={handleSubmit}
          id="owner-form"
          style={{
            overflowX: "hidden",
          }}
        >
          <div
            // className="mt-3"
            style={{
              flexGrow: 1,
              overflowY: "auto",
            }}
          >
            <Box sx={{ flex: 1, overflowY: "auto", p: 0, overflowX: "hidden" }}>
              {/* OWNER DIRECT FORM */}
              {formData.role === "owner" && (
                <>
                  <div
                    style={{
                      backgroundColor: "#f3f3f3", // light background
                      borderBottom: "1px solid #d3d3d3",
                      padding: "14px",
                      // borderRadius: "4px",
                    }}
                  >
                    <h5
                      style={{
                        fontWeight: 600,
                        color: "#646464",
                        fontSize: "16px",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Personal Information
                    </h5>
                  </div>
                  <div className="row p-3">
                    <div className="col-12 col-md-4">
                      <div className="form-group">
                        <label htmlFor="role">
                          User Type<span className="text-danger fs-4">*</span>
                        </label>
                        <select
                          name="role"
                          style={{ width: "100%", fontSize: "14px" }}
                          className="select-form-control-dropdown form-control"
                          value={formData.role}
                          onChange={(e) => {
                            handleChange(e);
                            // setEmailError("");
                            setEmptyFields(false);
                          }}
                          onBlur={handleBlur}
                        >
                          {/* <option value="">Select Role</option> */}
                          <option value="owner">Owner</option>
                          <option value="contractor">Contractor</option>
                          <option value="inspector">Inspector</option>
                        </select>
                      </div>
                    </div>
                    {/* <div>
                    {errorMsg !== "" && (
                      <span style={{ color: "red" }}>{errorMsg}</span>
                    )}
                  </div> */}
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="firstName"
                        placeholder="Enter First Name"
                        maxLength={60}
                        ref={firstNameRef}
                        className="form-control"
                        value={formData.firstName}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleChange}
                        style={borderStyle("firstName")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="lastName"
                        className="form-control"
                        placeholder="Enter Last Name"
                        maxLength={40}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.lastName}
                        onChange={handleChange}
                        style={borderStyle("lastName")}
                      />
                    </div>
                    <div className="col-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="email"
                        placeholder="Enter Email"
                        maxLength={255}
                        name="email"
                        onBlur={handleBlur}
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                        style={borderStyle("email")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Phone <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        // min={0}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        name="phone"
                        placeholder="Enter Phone Number"
                        className="form-control"
                        value={formData.phone}
                        onBlur={(e) => validatePhoneNumber(e.target.value)}
                        onChange={handleChange}
                        style={borderStyle("phone")}
                      />
                    </div>

                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Co-Owner Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        name="coOwnerName"
                        placeholder="Enter Co-Owner Name"
                        maxLength={500}
                        className="form-control"
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.coOwnerName}
                        onChange={handleChange}
                        style={borderStyle("coOwnerName")}
                      />
                    </div>
                    {emailErrors && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-4 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {emailErrors}
                        </span>
                      </div>
                    )}
                    {phoneNumError && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-4 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {phoneNumError}
                        </span>
                      </div>
                    )}
                    <div className="col-md-12 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Address <span className="text-danger">*</span>
                      </label>
                      <textarea
                        type="text"
                        name="address"
                        rows={3}
                        // readOnly={issubmitting}
                        className="form-control"
                        placeholder="Enter Address"
                        maxLength={100}
                        value={formData.address}
                        onChange={handleChange}
                        style={borderStyle("address")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        City <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        name="city"
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className="form-control"
                        placeholder="Enter City"
                        maxLength={100}
                        value={formData.city}
                        onChange={handleChange}
                        style={borderStyle("city")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        State <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        name="stateName"
                        placeholder="Enter State"
                        maxLength={100}
                        className="form-control"
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.stateName}
                        onChange={handleChange}
                        style={borderStyle("stateName")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Zip <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="number"
                        name="zip"
                        min={0}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "."
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className="form-control"
                        placeholder="Enter Zip"
                        onBlur={(e) => validateZipCode(e.target.value)}
                        value={formData.zip}
                        onChange={handleChange}
                        style={borderStyle("zip")}
                      />
                    </div>
                    {zipError && (
                      <div className={`col-12 mt-2`}>
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {zipError}
                        </span>
                      </div>
                    )}
                    {uploadOwnerFields.map(
                      ({ name, label, tooltip, accept }) => (
                        <div className="col-12 col-md-6 mt-3" key={name}>
                          {/* Label + Tooltip */}
                          <div
                            className="d-flex align-items-center justify-content-start mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            <label className="mb-0">
                              {label}{" "}
                              {label !== "EIN Confirmation Letter" ? (
                                <span className="text-danger">*</span>
                              ) : (
                                <span></span>
                              )}
                            </label>
                            <Tooltip title={tooltip}>
                              <span>
                                <IoMdInformationCircleOutline
                                  fontSize={"16px"}
                                  className="ms-1"
                                />
                              </span>
                            </Tooltip>
                          </div>

                          {/* Hidden Input */}
                          <input
                            readOnly={issubmitting}
                            type="file"
                            id={name}
                            name={name}
                            key={name}
                            onChange={handleChange}
                            disabled={issubmitting}
                            accept={accept}
                            multiple={name !== "CopyOfID"}
                            style={{ display: "none" }}
                          />

                          {/* Conditional rendering for CopyOfID */}
                          {name === "CopyOfID" ? (
                            // --- Single File Layout (like photoID) ---
                            <>
                              {!formData[name] ? (
                                <label
                                  htmlFor={name}
                                  className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                  style={{
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease-in-out",
                                    border: emptyFields[name]
                                      ? "1px solid red"
                                      : "1px dashed #878787ff",
                                    color: "878787ff",
                                  }}
                                  onMouseOver={(e) =>
                                    (e.currentTarget.style.background = "#fff")
                                  }
                                  onMouseOut={(e) =>
                                    (e.currentTarget.style.background = "#fff")
                                  }
                                >
                                  <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                  Upload
                                </label>
                              ) : (
                                <div
                                  className="d-flex align-items-center justify-content-between border rounded px-2 py-2 mt-2"
                                  style={{
                                    fontSize: "13px",
                                    backgroundColor: invalidFiles.includes(
                                      formData[name]?.[0]?.name
                                    )
                                      ? "#fff"
                                      : "#fff",
                                    border: invalidFiles.includes(
                                      formData[name]?.[0]?.name
                                    )
                                      ? "1px solid red"
                                      : "1px solid #ccc",
                                    borderRadius: "20px",
                                    cursor: "pointer",
                                  }}
                                >
                                  <div
                                    className="text-truncate"
                                    style={{ maxWidth: "80%" }}
                                    onClick={() => {
                                      const file = formData[name]?.[0];

                                      if (file) {
                                        const url = URL.createObjectURL(file);
                                        setSelectedPdfFile(url);
                                        setPreviewModaTitle("Photo ID");
                                        setPreviewModal(true);
                                      }
                                    }}
                                  >
                                    <TextSnippetIcon
                                      className="me-2"
                                      style={{ fontSize: 26, color: "#F5AE41" }}
                                    />{" "}
                                    {formData[name]?.[0]?.name}
                                  </div>
                                  <i
                                    className="fa-solid fa-xmark ms-2"
                                    style={{ cursor: "pointer", color: "grey" }}
                                    onClick={() => clearFile(name)}
                                  ></i>
                                </div>
                              )}
                            </>
                          ) : (
                            // --- Default Layout for multi-file fields ---
                            <>
                              <label
                                htmlFor={name}
                                className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                style={{
                                  fontWeight: 400,
                                  fontSize: "14px",
                                  borderRadius: "6px",
                                  cursor: "pointer",
                                  transition: "all 0.2s ease-in-out",
                                  border: emptyFields[name]
                                    ? "1px solid red"
                                    : "1px dashed #878787ff",
                                  color: "878787ff",
                                }}
                                onMouseOver={(e) =>
                                  (e.currentTarget.style.background = "#fff")
                                }
                                onMouseOut={(e) =>
                                  (e.currentTarget.style.background = "#fff")
                                }
                              >
                                <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                Upload
                              </label>

                              {Array.isArray(formData[name]) &&
                                formData[name].length > 0 && (
                                  <div className="d-flex flex-wrap mt-2 gap-2">
                                    {formData[name].map((file, index) => (
                                      <div
                                        key={index}
                                        className="d-flex align-items-center border rounded px-2 py-1"
                                        style={{
                                          fontSize: "13px",
                                          backgroundColor:
                                            invalidFiles.includes(file.name)
                                              ? "#fff"
                                              : "#fff",
                                          border: invalidFiles.includes(
                                            file.name
                                          )
                                            ? "1px solid red"
                                            : "1px solid #ccc",
                                          borderRadius: "20px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        <span
                                          className="text-truncate"
                                          style={{ maxWidth: "120px" }}
                                          onClick={() => {
                                            const filename = file.name;
                                            if (!filename) return;

                                            const url =
                                              URL.createObjectURL(file);
                                            const fileType = file.type;

                                            // Handle PDFs
                                            if (
                                              fileType === "application/pdf"
                                            ) {
                                              setSelectedPdfFile(url);
                                              setPreviewModaTitle(
                                                "Additional Documents"
                                              );
                                              setPreviewModal(true);
                                            }
                                            // For other file types (Excel, Word, etc.)
                                            else {
                                              const link =
                                                document.createElement("a");
                                              link.href = url;
                                              link.download = filename;
                                              document.body.appendChild(link);
                                              link.click();
                                              document.body.removeChild(link);
                                              URL.revokeObjectURL(url);
                                            }
                                          }}
                                        >
                                          <TextSnippetIcon
                                            className="me-2"
                                            style={{
                                              fontSize: 26,
                                              color: "#F5AE41",
                                            }}
                                          />{" "}
                                          {file.name}
                                        </span>
                                        <i
                                          className="fa-solid fa-xmark ms-2"
                                          style={{
                                            cursor: "pointer",
                                            color: "grey",
                                          }}
                                          onClick={() =>
                                            clearSingleFile(name, index)
                                          }
                                        ></i>
                                      </div>
                                    ))}
                                  </div>
                                )}
                            </>
                          )}

                          {/* Error Text */}
                          {errors[name] && (
                            <div
                              className="text-danger mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {errors[name]}
                            </div>
                          )}
                        </div>
                      )
                    )}
                  </div>
                  <div
                    style={{
                      backgroundColor: "#f3f3f3", // light background
                      borderBottom: "1px solid #d3d3d3",
                      padding: "14px",
                      // borderRadius: "4px",
                    }}
                    className="mt-2"
                  >
                    <h5
                      style={{
                        fontWeight: 600,
                        color: "#646464",
                        fontSize: "16px",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Bank Information
                    </h5>
                  </div>
                  <div className="row p-3">
                    <div className="col-md-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Account Holder <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="accountHolder"
                        className="form-control"
                        value={formData.accountHolder}
                        onChange={handleChange}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter Account Holder"
                        maxLength={100}
                        style={borderStyle("accountHolder")}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Bank Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="bankName"
                        className="form-control"
                        value={formData.bankName}
                        onChange={handleChange}
                        placeholder="Enter Bank Name "
                        maxLength={100}
                        style={borderStyle("bankName")}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <div
                        className="d-flex align-items-center justify-content-start"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        <label
                          className="mb-1"
                          style={{ fontWeight: 500, fontSize: "14px" }}
                        >
                          Wire Routing Number{" "}
                          <span className="text-muted">
                            (Wire transfers only, no ACH)
                          </span>{" "}
                          <span className="text-danger">*</span>
                        </label>
                        {/* <Tooltip title="Please enter the routing number used specifically for wire transfers (not for ACH).">
                 
                    <span>
                      <IoMdInformationCircleOutline
                        fontSize={"16px"}
                        className="ms-1 mb-1"
                      />
                    </span>
                  </Tooltip> */}
                      </div>
                      <input
                        // readOnly={issubmitting}
                        name="routingNumber"
                        type="number"
                        className="form-control"
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "."
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.routingNumber}
                        onBlur={(e) => validateRoutingNumber(e.target.value)}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= 9) {
                            handleChange(e);
                          }
                        }}
                        min={0}
                        max={999999999}
                        placeholder="Enter Routing Number"
                        style={borderStyle("routingNumber")}
                      />
                    </div>

                    <div className="col-md-6 mt-2">
                      <label
                        // className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Account Number <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="accountNumber"
                        className="form-control"
                        onBlur={(e) => validateAccountNumber(e.target.value)}
                        min={0}
                        max={99999999999999999}
                        placeholder="Enter  Account Number "
                        type="number"
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+" ||
                            e.key === "."
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.accountNumber}
                        onChange={(e) => {
                          const value = e.target.value;

                          // Allow empty string for deletion
                          if (value === "" || value.length <= 17) {
                            handleChange(e);
                          }
                        }}
                        style={borderStyle("accountNumber")}
                      />
                    </div>
                    {routingNumError && (
                      <div
                        className={
                          accountNumError && routingNumError
                            ? `col-6 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {routingNumError}
                        </span>
                      </div>
                    )}
                    {accountNumError && (
                      <div
                        className={
                          accountNumError && routingNumError
                            ? `col-6 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {accountNumError}
                        </span>
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* Inspector */}
              {formData.role === "inspector" && (
                <>
                  <div
                    style={{
                      backgroundColor: "#f3f3f3", // light background
                      borderBottom: "1px solid #d3d3d3",
                      padding: "14px",
                      // borderRadius: "4px",
                    }}
                  >
                    <h5
                      style={{
                        fontWeight: 600,
                        color: "#646464",
                        fontSize: "16px",
                        margin: 0,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Personal Information
                    </h5>
                  </div>
                  <div className="row p-3">
                    <div className="col-12 col-md-4">
                      <div className="form-group">
                        <label htmlFor="role">
                          User Type<span className="text-danger fs-4">*</span>
                        </label>
                        <select
                          name="role"
                          style={{ width: "100%", fontSize: "14px" }}
                          className="select-form-control-dropdown form-control"
                          value={formData.role}
                          onChange={(e) => {
                            handleChange(e);
                            // setEmailError("");
                            setEmptyFields(false);
                          }}
                          onBlur={handleBlur}
                        >
                          {/* <option value="">Select Role</option> */}
                          <option value="owner">Owner</option>
                          <option value="contractor">Contractor</option>
                          <option value="inspector">Inspector</option>
                        </select>
                      </div>
                    </div>
                    {/* <div>
                    {errorMsg !== "" && (
                      <span style={{ color: "red" }}>{errorMsg}</span>
                    )}
                  </div> */}
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        First Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="firstName"
                        placeholder="Enter First Name"
                        maxLength={60}
                        ref={firstNameRef}
                        className="form-control"
                        value={formData.firstName}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onChange={handleChange}
                        style={borderStyle("firstName")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Last Name <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        name="lastName"
                        className="form-control"
                        placeholder="Enter Last Name"
                        maxLength={40}
                        onKeyDown={(e) => {
                          // Block invalid keys before they appear
                          if (
                            !/^[a-zA-Z\s]$/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "Tab" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Delete"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        value={formData.lastName}
                        onChange={handleChange}
                        style={borderStyle("lastName")}
                      />
                    </div>
                    <div className="col-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Email <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="email"
                        placeholder="Enter Email"
                        maxLength={255}
                        name="email"
                        onBlur={handleBlur}
                        className="form-control"
                        value={formData.email}
                        onChange={handleChange}
                        style={borderStyle("email")}
                      />
                    </div>
                    <div className="col-md-4 mt-2">
                      <label
                        className="mb-1"
                        style={{ fontWeight: 500, fontSize: "14px" }}
                      >
                        Phone <span className="text-danger">*</span>
                      </label>
                      <input
                        // readOnly={issubmitting}
                        type="text"
                        // min={0}
                        onKeyDown={(e) => {
                          if (
                            e.key === "e" ||
                            e.key === "E" ||
                            e.key === "-" ||
                            e.key === "+"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        name="phone"
                        placeholder="Enter Phone Number"
                        className="form-control"
                        value={formData.phone}
                        onBlur={(e) => validatePhoneNumber(e.target.value)}
                        onChange={handleChange}
                        style={borderStyle("phone")}
                      />
                    </div>

                    <div className="col-12 col-md-4 ">
                      <div className="form-group">
                        <label htmlFor="designation">
                          Inspector Designation
                          <span className="text-danger fs-4">*</span>
                        </label>
                        <select
                          name="designation"
                          className="select-form-control-dropdown form-control"
                          value={formData.designation}
                          onChange={(e) => {
                            handleChange(e);
                            // setEmailError("");
                            setEmptyFields(false);
                          }}
                          onBlur={handleBlur}
                          style={borderStyle("designation")}
                        >
                          <option value="" disabled>
                            Select Designation
                          </option>
                          <option value="Commercial Building Inspector">
                            Commercial Building Inspector
                          </option>
                          <option value="Residential Building Inspector">
                            Residential Building Inspector
                          </option>
                          <option value="Combination Inspector">
                            Combination Inspector
                          </option>
                        </select>
                      </div>
                      {/* </div> */}
                    </div>
                    {emailErrors && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-4 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {emailErrors}
                        </span>
                      </div>
                    )}
                    {phoneNumError && (
                      <div
                        className={
                          emailErrors && phoneNumError
                            ? `col-4 mt-2`
                            : `col-12 mt-2`
                        }
                      >
                        <span
                          style={{ fontSize: "14px" }}
                          className="text-danger"
                        >
                          {phoneNumError}
                        </span>
                      </div>
                    )}
                  </div>
                </>
              )}

              {/* CONTRACTOR MULTI-STEP FORM */}
              {formData.role === "contractor" && (
                <>
                  {step === 1 && (
                    <>
                      {/* <h6 className="mb-3">Personal Details</h6> */}
                      <div
                        style={{
                          backgroundColor: "#f3f3f3", // light background
                          borderBottom: "1px solid #d3d3d3",
                          padding: "14px",
                          // borderRadius: "4px",
                        }}
                      >
                        <h5
                          style={{
                            fontWeight: 600,
                            color: "#646464",
                            fontSize: "16px",
                            margin: 0,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Personal Information
                        </h5>
                      </div>
                      <div className="row p-3">
                        <div className="col-12 col-md-4">
                          <div className="form-group">
                            <label htmlFor="role">
                              User Type
                              <span className="text-danger fs-4">*</span>
                            </label>
                            <select
                              name="role"
                              style={{ width: "100%", fontSize: "14px" }}
                              className="select-form-control-dropdown form-control"
                              value={formData.role}
                              onChange={(e) => {
                                handleChange(e);
                                // setEmailError("");
                                setEmptyFields(false);
                              }}
                              onBlur={handleBlur}
                            >
                              {/* <option value="">Select Role</option> */}
                              <option value="owner">Owner</option>
                              <option value="contractor">Contractor</option>
                              <option value="inspector">Inspector</option>
                            </select>
                          </div>
                        </div>
                        {/* <div>
                    {errorMsg !== "" && (
                      <span style={{ color: "red" }}>{errorMsg}</span>
                    )}
                  </div> */}
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            First Name <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="firstName"
                            placeholder="Enter First Name"
                            maxLength={60}
                            className="form-control"
                            ref={firstNameRef}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            value={formData.firstName}
                            onChange={handleChange}
                            style={borderStyle("firstName")}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Last Name <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="lastName"
                            className="form-control"
                            value={formData.lastName}
                            placeholder="Enter Last Name"
                            maxLength={40}
                            onChange={handleChange}
                            style={borderStyle("lastName")}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <div className="col-6 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Email <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="email"
                            type="email"
                            onBlur={handleBlur}
                            className="form-control"
                            placeholder="Enter Email"
                            maxLength={255}
                            value={formData.email}
                            onChange={handleChange}
                            style={borderStyle("email")}
                          />
                        </div>
                        <div className="col-6 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Phone <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="phone"
                            className="form-control"
                            type="text"
                            min={0}
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="Enter Phone Number"
                            value={formData.phone}
                            onBlur={(e) => validatePhoneNumber(e.target.value)}
                            onChange={handleChange}
                            style={borderStyle("phone")}
                          />
                        </div>
                        {emailErrors && (
                          <div
                            className={
                              emailErrors && phoneNumError
                                ? `col-6 mt-2`
                                : `col-12 mt-2`
                            }
                          >
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {emailErrors}
                            </span>
                          </div>
                        )}
                        {phoneNumError && (
                          <div
                            className={
                              emailErrors && phoneNumError
                                ? `col-6 mt-2`
                                : `col-12 mt-2`
                            }
                          >
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {phoneNumError}
                            </span>
                          </div>
                        )}

                        <div className="col-md-12 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Address <span className="text-danger">*</span>
                          </label>
                          <textarea
                            name="address"
                            rows={3}
                            className="form-control"
                            // readOnly={issubmitting}
                            value={formData.address}
                            onChange={handleChange}
                            placeholder="Enter Address"
                            maxLength={100}
                            style={borderStyle("address")}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            City <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="city"
                            className="form-control"
                            value={formData.city}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="Enter City"
                            maxLength={100}
                            onChange={handleChange}
                            style={borderStyle("city")}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            State <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="stateName"
                            className="form-control"
                            value={formData.stateName}
                            onChange={handleChange}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="Enter State"
                            maxLength={100}
                            style={borderStyle("stateName")}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Zip <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="zip"
                            type="number"
                            min={0}
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+" ||
                                e.key === "."
                              ) {
                                e.preventDefault();
                              }
                            }}
                            className="form-control"
                            value={formData.zip}
                            onChange={handleChange}
                            onBlur={(e) => validateZipCode(e.target.value)}
                            style={borderStyle("zip")}
                            placeholder="Enter Zip"
                          />
                        </div>
                        {zipError && (
                          <div className={`col-12 mt-2`}>
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {zipError}
                            </span>
                          </div>
                        )}
                        {uploadContractorFields.map(
                          ({ name, label, tooltip, accept }) => (
                            <>
                              {name === "photoID" && (
                                <div className="col-12 mt-3" key={name}>
                                  <div
                                    className="d-flex align-items-center justify-content-start mb-1"
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    <label className="mb-0">
                                      {label}{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Tooltip title={tooltip}>
                                      <span>
                                        <IoMdInformationCircleOutline
                                          fontSize={"16px"}
                                          className="ms-1 mb-1"
                                        />
                                      </span>
                                    </Tooltip>
                                  </div>

                                  {/* Hidden Input */}
                                  <input
                                    readOnly={issubmitting}
                                    type="file"
                                    id={name}
                                    name={name}
                                    onChange={handleChange}
                                    disabled={issubmitting}
                                    accept={accept}
                                    style={{ display: "none" }}
                                  />

                                  {/* Upload Button or File Display */}
                                  {!formData[name] ? (
                                    <label
                                      htmlFor={name}
                                      className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                      style={{
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        borderRadius: "6px",
                                        height: "50px",
                                        cursor: "pointer",
                                        transition: "all 0.2s ease-in-out",
                                        border: emptyFields[name]
                                          ? "1px solid red"
                                          : "1px dashed #878787ff",
                                        color: "878787ff",
                                      }}
                                      onMouseOver={(e) =>
                                        (e.currentTarget.style.background =
                                          "#fff")
                                      }
                                      onMouseOut={(e) =>
                                        (e.currentTarget.style.background =
                                          "#fff")
                                      }
                                    >
                                      <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                      Upload
                                    </label>
                                  ) : (
                                    <div
                                      className="d-flex align-items-center border rounded px-2 py-2 justify-content-between"
                                      style={{
                                        fontSize: "13px",
                                        backgroundColor: invalidFiles.includes(
                                          formData[name]?.name
                                        )
                                          ? "#fff" // 🟥 light red background if invalid
                                          : "#fff",
                                        border: invalidFiles.includes(
                                          formData[name]?.name
                                        )
                                          ? "1px solid red"
                                          : "1px solid #ccc",
                                        borderRadius: "20px",
                                        transition: "all 0.3s ease-in-out",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <div
                                        className="text-truncate"
                                        style={{ maxWidth: "80%" }}
                                        onClick={() => {
                                          const file = formData[name];

                                          if (file) {
                                            const url =
                                              URL.createObjectURL(file);
                                            setSelectedPdfFile(url);
                                            setPreviewModaTitle("Photo ID");
                                            setPreviewModal(true);
                                          }
                                        }}
                                      >
                                        <TextSnippetIcon
                                          className="me-2"
                                          style={{
                                            fontSize: 26,
                                            color: "#F5AE41",
                                          }}
                                        />{" "}
                                        {formData[name].name}
                                        {/* {invalidFiles.includes(
                                                formData[name]?.name
                                              ) && (
                                                <i
                                                  className="fa-solid fa-triangle-exclamation ms-2"
                                                  style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                  }}
                                                  title="This file could not be read. Please re-upload."
                                                ></i>
                                              )} */}
                                      </div>
                                      <i
                                        className="fa-solid fa-xmark ms-2"
                                        style={{
                                          cursor: "pointer",
                                          color: "grey",
                                        }}
                                        onClick={() => clearFile(name)}
                                      ></i>
                                    </div>
                                  )}

                                  {/* Error Text */}
                                  {errors[name] && (
                                    <div
                                      className="text-danger mt-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {errors[name]}
                                    </div>
                                  )}
                                </div>
                              )}
                            </>
                          )
                        )}
                      </div>

                      <div
                        style={{
                          backgroundColor: "#f3f3f3", // light background
                          borderBottom: "1px solid #d3d3d3",
                          padding: "14px",
                          // borderRadius: "4px",
                        }}
                        className="mt-2"
                      >
                        <h5
                          style={{
                            fontWeight: 600,
                            color: "#646464",
                            fontSize: "16px",
                            margin: 0,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Business Information
                        </h5>
                      </div>

                      {/* <h6 className="mb-3"> Company Details</h6> */}
                      <div className="row p-3">
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Company Name <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="companyName"
                            className="form-control"
                            value={formData.companyName}
                            onChange={handleChange}
                            // onKeyDown={(e) => {
                            //   // Block invalid keys before they appear
                            //   if (
                            //     !/^[a-zA-Z\s]$/.test(e.key) &&
                            //     e.key !== "Backspace" &&
                            //     e.key !== "Tab" &&
                            //     e.key !== "ArrowLeft" &&
                            //     e.key !== "ArrowRight" &&
                            //     e.key !== "Delete"
                            //   ) {
                            //     e.preventDefault();
                            //   }
                            // }}
                            style={borderStyle("companyName")}
                            placeholder="Enter Company Name"
                            maxLength={500}
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Year Founded <span className="text-danger">*</span>
                          </label>
                          <Select
                            options={yearOptions}
                            value={yearOptions.find(
                              (option) => option.value === formData.yearFounded
                            )} // Ensure selected year is reflected
                            onChange={(selected) =>
                              handleChange({
                                target: {
                                  name: "yearFounded",
                                  value: selected.value,
                                },
                              })
                            }
                            isDisabled={issubmitting}
                            // readOnly={issubmitting}
                            className="w-100"
                            styles={{
                              control: (base) => ({
                                ...base,
                                ...borderStyle("yearFounded"),
                                minHeight: "34px",

                                marginTop: "2.5px",
                              }),
                              option: (base) => ({
                                ...base,
                                paddingTop: 4,
                                paddingBottom: 4,
                              }),
                            }}
                            placeholder="Select Founded Year"
                          />
                        </div>
                        <div className="col-md-4 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Number of Employees{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            type="number"
                            name="employees"
                            className="form-control"
                            min={1}
                            placeholder="Enter Number of Employees"
                            value={formData.employees}
                            onChange={(e) => {
                              const value = e.target.value;
                              setEmptyFields((prev) => ({
                                ...prev,
                                employees: false,
                              }));

                              if (value.length > 10) {
                                // If user types more than 10 characters, ignore extra input
                                return;
                              }

                              if (value === "" || parseInt(value) < 1) {
                                setFormData((prev) => ({
                                  ...prev,
                                  employees: "",
                                }));
                              } else {
                                setFormData((prev) => ({
                                  ...prev,
                                  employees: parseInt(value),
                                }));
                              }
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+" ||
                                e.key === "." ||
                                (e.key === "0" && e.target.value === "")
                              ) {
                                e.preventDefault();
                              }
                            }}
                            style={borderStyle("employees")}
                          />
                        </div>
                        <div className="col-12 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Contractor License Information{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="contractorLicense"
                            className="form-control"
                            placeholder="Enter Contractor License Information"
                            value={formData.contractorLicense}
                            onChange={handleChange}
                            style={borderStyle("contractorLicense")}
                          />
                        </div>
                        {uploadContractorFields.map(
                          ({ name, label, tooltip, accept }) => (
                            <>
                              {name !== "photoID" && (
                                <div className="col-12 mt-3" key={name}>
                                  <div
                                    className="d-flex align-items-center justify-content-start mb-1"
                                    style={{
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    <label className="mb-0">
                                      {label}{" "}
                                      <span className="text-danger">*</span>
                                    </label>
                                    <Tooltip title={tooltip}>
                                      <span>
                                        <IoMdInformationCircleOutline
                                          fontSize={"16px"}
                                          className="ms-1 mb-1"
                                        />
                                      </span>
                                    </Tooltip>
                                  </div>

                                  {/* Hidden Input (Multiple File Support) */}
                                  <input
                                    readOnly={issubmitting}
                                    type="file"
                                    id={name}
                                    name={name}
                                    onChange={(e) => handleChange(e, name)}
                                    disabled={issubmitting}
                                    accept={accept}
                                    multiple
                                    style={{ display: "none" }}
                                  />

                                  {/* Upload Button */}
                                  <label
                                    htmlFor={name}
                                    className="btn w-100 d-flex align-items-center justify-content-center gap-2 py-2"
                                    style={{
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      borderRadius: "6px",
                                      cursor: "pointer",
                                      height: "50px",
                                      transition: "all 0.2s ease-in-out",
                                      border: emptyFields[name]
                                        ? "1px solid red"
                                        : "1px dashed #878787ff",
                                      color: "878787ff",
                                    }}
                                    onMouseOver={(e) =>
                                      (e.currentTarget.style.background =
                                        "#fff")
                                    }
                                    onMouseOut={(e) =>
                                      (e.currentTarget.style.background =
                                        "#fff")
                                    }
                                  >
                                    <i className="fa-solid fa-arrow-up-from-bracket"></i>
                                    Upload
                                  </label>

                                  {/* Display Uploaded Files as Chips */}
                                  {formData[name]?.length > 0 && (
                                    <div className="d-flex flex-wrap mt-2 gap-2">
                                      {formData[name].map((file, index) => (
                                        <div
                                          key={index}
                                          className="d-flex align-items-center border rounded px-2 py-1"
                                          style={{
                                            fontSize: "13px",
                                            backgroundColor:
                                              invalidFiles.includes(file.name)
                                                ? "#fff" // light red background
                                                : "#fff",
                                            border: invalidFiles.includes(
                                              file.name
                                            )
                                              ? "1px solid red"
                                              : "1px solid #ccc",
                                            borderRadius: "20px",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span
                                            className="text-truncate"
                                            style={{ maxWidth: "120px" }}
                                            onClick={() => {
                                              const filename = file.name;
                                              if (!filename) return;

                                              const url =
                                                URL.createObjectURL(file);
                                              const fileType = file.type;

                                              // Handle PDFs
                                              if (
                                                fileType === "application/pdf"
                                              ) {
                                                setSelectedPdfFile(url);
                                                setPreviewModaTitle(
                                                  "Additional Documents"
                                                );
                                                setPreviewModal(true);
                                              }
                                              // For other file types (Excel, Word, etc.)
                                              else {
                                                const link =
                                                  document.createElement("a");
                                                link.href = url;
                                                link.download = filename;
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                                URL.revokeObjectURL(url);
                                              }
                                            }}
                                          >
                                            <TextSnippetIcon
                                              className="me-2"
                                              style={{
                                                fontSize: 26,
                                                color: "#F5AE41",
                                              }}
                                            />{" "}
                                            {file.name}
                                          </span>
                                          <i
                                            className="fa-solid fa-xmark ms-2"
                                            style={{
                                              cursor: "pointer",
                                              color: "grey",
                                            }}
                                            onClick={() =>
                                              clearSingleFile(name, index)
                                            }
                                          ></i>
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {errors[name] && (
                                    <div
                                      className="text-danger mt-1"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {errors[name]}
                                    </div>
                                  )}
                                </div>
                              )}
                            </>
                          )
                        )}
                      </div>
                      {/* <h6 className="mb-2 mt-3">Bank Details</h6> */}
                      <div
                        style={{
                          backgroundColor: "#f3f3f3", // light background
                          borderBottom: "1px solid #d3d3d3",
                          padding: "14px",
                          // borderRadius: "4px",
                        }}
                      >
                        <h5
                          style={{
                            fontWeight: 600,
                            color: "#646464",
                            fontSize: "16px",
                            margin: 0,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Bank Information
                        </h5>
                      </div>
                      <div className="row p-3">
                        <div className="col-md-6 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Account Holder{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="accountHolder"
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                            className="form-control"
                            value={formData.accountHolder}
                            onChange={handleChange}
                            placeholder="Enter Account Holder"
                            maxLength={100}
                            style={borderStyle("accountHolder")}
                          />
                        </div>
                        <div className="col-md-6 mt-2">
                          <label
                            className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Bank Name <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="bankName"
                            className="form-control"
                            value={formData.bankName}
                            onChange={handleChange}
                            placeholder="Enter Bank Name "
                            maxLength={100}
                            style={borderStyle("bankName")}
                            onKeyDown={(e) => {
                              // Block invalid keys before they appear
                              if (
                                !/^[a-zA-Z\s]$/.test(e.key) &&
                                e.key !== "Backspace" &&
                                e.key !== "Tab" &&
                                e.key !== "ArrowLeft" &&
                                e.key !== "ArrowRight" &&
                                e.key !== "Delete"
                              ) {
                                e.preventDefault();
                              }
                            }}
                          />
                        </div>
                        <div className="col-md-6 mt-2">
                          <div
                            className="d-flex align-items-center justify-content-start"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            <label
                              className="mb-1"
                              style={{ fontWeight: 500, fontSize: "14px" }}
                            >
                              Wire Routing Number{" "}
                              <span className="text-muted">
                                (Wire transfers only, no ACH)
                              </span>{" "}
                              <span className="text-danger">*</span>
                            </label>
                            {/* <Tooltip title="Please enter the routing number used specifically for wire transfers (not for ACH).">
                                          
                                          <span>
                                            <IoMdInformationCircleOutline
                                              fontSize={"16px"}
                                              className="ms-1 mb-1"
                                            />
                                          </span>
                                        </Tooltip> */}
                          </div>
                          <input
                            // readOnly={issubmitting}
                            name="routingNumber"
                            type="number"
                            className="form-control"
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+" ||
                                e.key === "."
                              ) {
                                e.preventDefault();
                              }
                            }}
                            value={formData.routingNumber}
                            onBlur={(e) =>
                              validateRoutingNumber(e.target.value)
                            }
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value.length <= 9) {
                                handleChange(e);
                              }
                            }}
                            min={0}
                            max={999999999}
                            placeholder="Enter Routing Number"
                            style={borderStyle("routingNumber")}
                          />
                        </div>
                        <div className="col-md-6 mt-2">
                          <label
                            // className="mb-1"
                            style={{ fontWeight: 500, fontSize: "14px" }}
                          >
                            Account Number{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            // readOnly={issubmitting}
                            name="accountNumber"
                            className="form-control"
                            min={0}
                            max={99999999999999999}
                            placeholder="Enter  Account Number "
                            type="number"
                            onKeyDown={(e) => {
                              if (
                                e.key === "e" ||
                                e.key === "E" ||
                                e.key === "-" ||
                                e.key === "+" ||
                                e.key === "."
                              ) {
                                e.preventDefault();
                              }
                            }}
                            value={formData.accountNumber}
                            onBlur={(e) =>
                              validateAccountNumber(e.target.value)
                            }
                            onChange={(e) => {
                              const value = e.target.value;

                              // Allow empty string for deletion
                              if (value === "" || value.length <= 17) {
                                handleChange(e);
                              }
                            }}
                            style={borderStyle("accountNumber")}
                          />
                        </div>
                        {routingNumError && (
                          <div
                            className={
                              accountNumError && routingNumError
                                ? `col-6 mt-2`
                                : `col-12 mt-2`
                            }
                          >
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {routingNumError}
                            </span>
                          </div>
                        )}
                        {accountNumError && (
                          <div
                            className={
                              accountNumError && routingNumError
                                ? `col-6 mt-2`
                                : `col-12 mt-2`
                            }
                          >
                            <span
                              style={{ fontSize: "14px" }}
                              className="text-danger"
                            >
                              {accountNumError}
                            </span>
                          </div>
                        )}

                        {/* Documents for Contractor */}
                        {/* <div className="row"> */}

                        {/* </div> */}
                      </div>
                    </>
                  )}
                </>
              )}
            </Box>
          </div>
          <div
            style={{
              position: "sticky",
              bottom: 0,
              background: "#fff",
              borderTop: "1px solid #ddd",
              padding: "16px 24px",
              textAlign: "right",
            }}
          >
            <button
              className="btn btn-cvault ms-auto mt-3 d-flex align-items-center justify-content-center"
              style={{ width: "25%" }}
              onClick={handleSubmit}
              disabled={issubmitting}
            >
              {issubmitting ? (
                <>
                  <span className="me-2">Creating user...</span>
                  <CircularProgress size={18} color="inherit" />
                </>
              ) : (
                "Create User"
              )}
            </button>
          </div>
        </form>
      </Drawer>

      {isLoader && (
        <div className="loader-overlay">
          <span className="loader-message">
            Fetching document from cloud storage. Please wait...
          </span>

          <BarLoader
            color="#F5AE41"
            width={"80%"}
            height={5}
            className="loader"
            loading={isLoader}
          />
        </div>
      )}

      <Modal
        open={previewModal}
        onClose={() => {
          setPreviewModal(false);
          setPreviewModaTitle("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            // maxHeight: "100vh", // Ensure the modal does not exceed viewport height
            overflowY: "auto",
          }}
        >
          <div>
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <div>
                <h5>{previewModaTitle}</h5>
              </div>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setPreviewModal(false);
                  setPreviewModaTitle("");
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedPdfFile && (
                <iframe
                  title="PDF Viewer"
                  style={iframeStyleContractPdf}
                  src={selectedPdfFile}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </Box>
  );
}

export default ViewUsers;
